import React, {
  createContext,
  FC,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { AxiosError } from "axios";
import * as Sentry from "@sentry/browser";
import { NoTokenError } from "@bn/api";
import { useMyself } from "@api";

export const AuthContext = createContext<{
  setLoginRequired: (error: AxiosError<ApiException> | NoTokenError) => void;
}>({
  setLoginRequired: () => {
    // eslint-disable-next-line no-console
    console.warn("No <AuthProvider/> Found. Login form will not be shown.");
  },
});

interface Props {
  children: ReactNode;
  loginComponent: FC<{
    error?: AxiosError<ApiException> | NoTokenError;
    clearAuthStates?: () => void;
  }>;
}

export const AuthProvider = ({ children, loginComponent }: Props) => {
  const [loginRequired, setLoginRequired] = useState(false);
  const [error, setError] = useState<AxiosError<ApiException> | NoTokenError>();
  const { data: myself } = useMyself();

  useEffect(() => {
    if (myself) {
      Sentry.setUser({ id: String(myself.id), email: myself.email });
    }
  }, [myself]);

  const handleLoginRequired = (
    err: AxiosError<ApiException> | NoTokenError
  ) => {
    setLoginRequired(true);
    setError(err);
  };

  const clearStates = () => {
    setLoginRequired(false);
    setError(undefined);
  };

  return (
    <AuthContext.Provider value={{ setLoginRequired: handleLoginRequired }}>
      {loginRequired
        ? React.createElement(loginComponent, {
            error: error,
            clearAuthStates: clearStates,
          })
        : children}
    </AuthContext.Provider>
  );
};
